import {
    CLEARFILTER,
    SELECTEDAUTHOR,
    SELECTEDCATEGORY,
    TYPEDINPUT,
} from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SELECTEDCATEGORY:
            return {
                ...state,
                category: action.payload,
            };

        case SELECTEDAUTHOR:
            return {
                ...state,
                author: action.payload,
            };

        case CLEARFILTER:
            return {
                ...state,
                category: "",
                author: "",
                input: "",
            };

        case TYPEDINPUT:
            return {
                ...state,
                input: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;
